module.exports = __webpack_public_path__ + "img/black_friday_deal_text_d_plp.5d830af.svg";